import React from 'react';
type SparkleProps = {
  className?: string;
};
export function Sparkle({
  className = 'h-5 w-5'
}: SparkleProps) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" className={className} fill="currentColor" data-id="element-154" data-mp="12qx404diyqu3">
      <path d="M12 0C12.9 7.6 16.4 11.1 24 12C16.4 12.9 12.9 16.4 12 24C11.1 16.4 7.6 12.9 0 12C7.6 11.1 11.1 7.6 12 0Z" data-id="element-155" data-mp="1hfjjq772dklu" />
    </svg>;
}